"use strict";

import http from "@/http";

const BASE_NAME = "/tags";

const list = async () => {
  const response = await http.get(BASE_NAME);
  return response.data;
};

const create = async ({ name, color, payroll }) => {
  const response = await http.post(BASE_NAME, { name, color, payroll });
  return response.data;
};

const edit = async (id, { name, color, payroll, reportLabel, gender }) => {
  const response = await http.put(`${BASE_NAME}/${id}`, { name, color, payroll, reportLabel, gender });
  return response.data;
};

const remove = async id => {
  await http.delete(`${BASE_NAME}/${id}`);
};

export default { list, create, edit, remove };
